import React ,{useEffect,useState} from 'react'
import '../App.css';
import promote3 from '../Image/Promote3.png';
import promote4 from '../Image/Promote4.png';
import calendar from '../icon/icons8-calendar-96.png';
import axios from 'axios';


function Event() {
  //data get from php file
    const [data,setData] = useState([]);
    let counter =1;


    //connect to api to get result
    function connectPhp(){
        let data =[];
        axios.get("https://www.pta-hk.com/getEventList.php").then
        (response=>{
            data = response.data;
            setData(data);
            console.log(data);
        }).catch((e)=>console.log(e));
    }

    useEffect(()=>{
        connectPhp();
    },[]);


  return (
    <div className="container">
        <div className="banner-section">
            <img src={ promote4 }
                alt="Poker Tournament Association"
                className="bannerImage3"
            />
        </div>
        <div className="container-content">
             <div className="eventTable">
                <div className="eventTable-container">
                <div className="title">比賽日程 &nbsp;&nbsp;
                    <img src={ calendar }
                        alt="Poker Tournament Association"
                        className="icon"
                />

                </div>
                <table className="event-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>編號</th>
                            <th>日期</th>
                            <th>時間</th>
                            <th>名稱</th>
                            <th>入場費</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item)=>(
                            <tr key={item.id}>
                                <td>{counter++}</td>
                                <td>{item.EventId}</td>
                                <td>{item.StartDate}</td>
                                <td>{item.StartTime}</td>
                                <td>{item.EventGame}</td>
                                <td>{item.Fee}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                </div>
            </div>
        </div>    
        <div className="banner-section">
            <img src={ promote3 }
                alt="Poker Tournament Association"
                className="bannerImage3"
            />
        </div>            
    </div>
    
  )
}

export default Event
